const synopsis = ($) => {

	$("#js-synopsis-button-more").on("click", () => {
		$("#js-synopsis-after").addClass("open");
		$("#js-synopsis-button-more").addClass("hide");
		$("#js-synopsis-button-less").addClass("show");
	});

	$("#js-synopsis-button-less").on("click", () => {
		$("#js-synopsis-after").removeClass("open");
		$("#js-synopsis-button-more").removeClass("hide");
		$("#js-synopsis-button-less").removeClass("show");
	});
}

export default synopsis;
